import type { MapBounds } from '@/shared/map';
import type { PlannerSourceSearch } from './source-search-params';

// Search patches written when the planner map drives the URL. The viewport
// bbox and the custom region are mutually exclusive, so each patch clears the
// other; both reset pagination. Fed to `mergeSourceSearch`.

export const boundsToSourcePatch = (
  bounds: MapBounds
): Partial<PlannerSourceSearch> => ({
  sourceNeLat: bounds.northEastLat,
  sourceNeLng: bounds.northEastLng,
  sourceSwLat: bounds.southWestLat,
  sourceSwLng: bounds.southWestLng,
  sourceRegionId: undefined,
  sourcePage: undefined,
});

export const regionToSourcePatch = (
  regionId: string | null
): Partial<PlannerSourceSearch> => ({
  sourceRegionId: regionId ?? undefined,
  sourceNeLat: undefined,
  sourceNeLng: undefined,
  sourceSwLat: undefined,
  sourceSwLng: undefined,
  sourcePage: undefined,
});

// Seeds the product picker from the active chapter (mirrors the legacy
// planner's chapter → product-filter sync). The chapter's `regionId` is a
// custom-region UUID, so it rides the same `sourceRegionId` → `customRegionIds`
// path as the map's region picker; its `country` scopes the list too. A null
// chapter (the "All chapters" reset) clears both. Like `regionToSourcePatch`
// it clears any viewport bbox (region and bbox are mutually exclusive) and
// resets pagination so the consultant lands on page 1 of the new scope.
export const chapterToSourcePatch = (
  chapter: { country: string | null; regionId: string | null } | null
): Partial<PlannerSourceSearch> => ({
  sourceCountry: chapter?.country ? [chapter.country] : undefined,
  sourceRegionId: chapter?.regionId ?? undefined,
  sourceNeLat: undefined,
  sourceNeLng: undefined,
  sourceSwLat: undefined,
  sourceSwLng: undefined,
  sourcePage: undefined,
});
